"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGridStyles = void 0;
var _classNames = require("./classNames");
var _styles = require("@gogame/ui/styles");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useGridStyles = exports.useGridStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      backgroundColor: theme.palette.background.paper
    }, '& .MuiDataGrid-pinnedRows .MuiDataGrid-cell', {
      // pinnedRows rule name does not work in data-grid 7.2.0
      fontWeight: 700
    }), '& .MuiDataGrid-columnHeader--pinnedLeft', {
      background: theme.palette.background.paper
    }), '& .MuiDataGrid-filler--pinnedLeft, & .MuiDataGrid-filler--pinnedRight', {
      height: '0 !important'
    }), "& .".concat(_classNames.COLLAPSED_COLUMN_HEADER), _defineProperty(_defineProperty({
      padding: '0 !important'
    }, '& .MuiDataGrid-columnSeparator, & .MuiDataGrid-iconButtonContainer', {
      display: 'none  !important'
    }), '& .MuiDataGrid-menuIcon', {
      // hide menu icon, display none affect menu appearance
      position: 'absolute',
      left: '-999999px'
    })), "& .".concat(_classNames.COLLAPSED_CELL), {
      padding: '0 !important',
      backgroundColor: 'inherit'
    }), '& .MuiDataGrid-detailPanel', {
      backgroundColor: theme.palette.background.paper,
      borderTop: "1px solid ".concat(theme.palette.divider),
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }),
    main: {
      '& .MuiDataGrid-row:hover': {
        backgroundColor: theme.palette.background.paper // disable row hover
      }
    },
    // dataGridContainer: {
    //   boxShadow:
    //     '0px 1px 3px 0px #00000033, 0px 2px 1px 0px #0000001F, 0px 1px 1px 0px #00000024',
    // },
    mainInitial: {
      borderTop: 'none'
    },
    mainFetching: {
      pointerEvents: 'none'
    },
    disabledPadding: {
      padding: '0 !important'
    },
    pinnedColumnHeaders: {
      scrollbarGutter: 'stable',
      paddingRight: '0 !important'
    },
    // virtualScrollerContentFetching: { opacity: 0.44 },
    virtualScroller: {
      overflowY: 'scroll !important'
    },
    // pinnedRowsFetching: { '& > div': { '& > div': { opacity: 0.44 } } },
    toolbarContainer: {
      padding: 0,
      gap: 0
    },
    // moved to root until grid fix rule name fix
    // pinnedRows: {
    //   fontWeight: 700,
    //   boxShadow: 'rgba(0, 0, 0, 0.21) 0px 2px 4px -2px',
    // },
    footerContainer: {
      minHeight: 64
    },
    // lastVisible: {
    //   '& > div': {
    //     borderBottomColor: `${theme.palette.divider} !important`,
    //   },
    // },
    displayNone: {
      display: 'none'
    },
    overlayWrapper: {},
    overlayWrapperInner: {
      background: (0, _styles.alpha)(theme.palette.background.paper, theme.palette.action.disabledOpacity)
    },
    columnHeader: {
      color: theme.palette.text.secondary,
      '&:focus': {
        outline: 'none !important'
      },
      '&:focus-within': {
        outline: 'none !important'
      },
      // fix for column header left margin
      '& .MuiDataGrid-menuIcon': {
        display: 'none'
      },
      '& .MuiDataGrid-menuIcon.MuiDataGrid-menuOpen, &:hover .MuiDataGrid-menuIcon': {
        display: 'flex'
      },
      '&.MuiDataGrid-columnHeader--sorted': {
        fontWeight: 700
      },
      '&[aria-colindex="1"]:not(.MuiDataGrid-columnHeaderCheckbox):not(.MuiDataGrid-columnHeader--alignRight)': {
        paddingLeft: '16px'
      }
    },
    cell: {
      '&[aria-colindex="1"]:not(.MuiDataGrid-cellCheckbox)': {
        paddingLeft: '16px'
      },
      '&:focus': {
        outline: 'none !important'
      },
      '&:focus-within': {
        outline: 'none !important'
      },
      '&.MuiDataGrid-cellCheckbox .MuiFormControl-root': {
        marginRight: function marginRight(_ref) {
          var allPageSelection = _ref.allPageSelection;
          return allPageSelection ? '16px' : 0;
        }
      }
    },
    menu: {
      width: 140
    },
    scrollbarHorizontal: {
      zIndex: 5
    }
  };
}, {
  name: 'GgDataGrid'
});